import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {DEFAULT_LANGUAGE} from '@/constants/constants';

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
})
